import api from '@/api'

const globalConfig = {
  state: {
    config: {
      // step 1
      marketingCityList: [],
      mainBusinessList: [{ mainBusiness: '', businessList: '' }],
      // step 2
      brandNames: '',
      conpetitives: ''
    }
  },

  mutations: {
    SET_CONFIG (state, { config }) {
      // 当接口返回null/[]时，赋默认值
      const { mainBusinessList: _mainBusinessList } = config
      const mainBusinessList = (_mainBusinessList && _mainBusinessList.length)
        ? _mainBusinessList
        : [{ mainBusiness: '', businessList: '' }]

      state.config = {
        marketingCityList: config.marketingCityList,
        mainBusinessList: mainBusinessList,
        brandNames: config.brandNames || '',
        conpetitives: config.conpetitives || ''
      }
    }
  },

  actions: {
    setGlobalConfig ({ commit }, data) {
      return api.config.setGlobalConfig(data).then(response => {
        commit('SET_CONFIG', data.body)
        return response
      })
    },

    getGlobalConfig ({ commit }, data) {
      return api.config.getGlobalConfig(data).then(response => {
        commit('SET_CONFIG', response.data)
        return response
      })
    },

    setGlobalConfigStatus ({ commit }, data) {
      return api.config.setGlobalConfigStatus(data)
    }
  }
}

export default globalConfig
